import { gql } from "@apollo/client";

export const PURCHASE_CUSTOM_TIP = gql`
  mutation PurchaseCustomTip($menuItemType: String!) {
    purchaseCustomTip(menuItemType: $menuItemType)
  }
`;
